import { SelectedMenu } from 'rangeConfig/@types';
import replaceProduct from 'rangeConfig/shared/behaviors/replaceProduct';
import { matchDimensions } from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import platform from 'rangeConfig/shared/utils/platform';
import deleteProduct from 'rangeConfig/shared/behaviors/deleteProduct';
import { filterDoorType } from 'rangeConfig/billy/filters/selectedMenuProductFilters';
import { CoreApi } from '@inter-ikea-storageone/range';
import { DirectionFilter } from 'rangeConfig/billy/widgets/DirecitonFilter/DirectionFilter';
import { forgetDoorChoices } from 'rangeConfig/billy/behaviours/forgetDoorChoices';
import { hideDoorDirectionFromDoorsSelectedMenu } from 'rangeConfig/billy/rules/hideMenuRules';

const widgets = {
  desktop: [
    {
      id: 'doors-selected-menu-doors',
      component: DirectionFilter,
      title: 'storageone.selectedProductListDoorOpeningDirection',
      hidden: (coreApi: CoreApi) => hideDoorDirectionFromDoorsSelectedMenu(coreApi)
    },
    {
      id: 'doors-selected-menu-doors',
      title: 'storageone.productListInteriorsTitle',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText',
      behaviors: {
        productClicked: [replaceProduct],
        productDropped: [replaceProduct]
      },
      productFilters: [matchDimensions, filterDoorType],
      sortOrder: [{ path: 'designText', reverse: true }]
    }
  ],
  mobile: [
    {
      id: 'doors-selected-menu-doors',
      title: 'storageone.productListInteriorsTitle',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText',
      behaviors: {
        productClicked: [replaceProduct],
        productDropped: [replaceProduct]
      },
      productFilters: [matchDimensions, filterDoorType],
      sortOrder: [{ path: 'designText', reverse: true }]
    }
  ]
};

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListCustomiseDoor',
  behaviors: {
    productDeleted: [deleteProduct],
    selectedMenuExited: [forgetDoorChoices]
  },
  content: widgets[platform]
};

export default selectedMenu;
